import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import BntMoreSupply from '../PopUps/BntMoreSupply';
import PowerButton from '../Button/ButtonCard/PowerButton';
import { Box, Typography } from '@mui/material';
import './Card.css';

const PowerSupply = ({ handleBasePower, module, handleRedundantPower, reset }) => {
  const [selected, setSelected] = useState(null);
  const handleSelectBase = () => {
    setSelected('base');
    handleBasePower(module);
  };

  const handleSelectRedundant = () => {
    setSelected('redundant');
    handleRedundantPower(module);
  };

    useEffect(() => {
        setSelected(null);
    }, [reset]);
    
  return (
    <Card
      variant="outlined"
      sx={{
       width: '430px',
      height: '240px',
      border: 'none',
      boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
      }}
    >
      
      <CardContent>
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
          }}
        >
          <Typography
            variant="h6"
            component="h3"
            sx={{
              fontFamily: 'Open Sans',
              m: 0,
              ml: 1,
              fontWeight: 'bold',
            }}
          >
            Power Supply
          </Typography>

          <BntMoreSupply
            size="small"
            sx={{
              minWidth: 'auto',
              padding: 1,
              borderRadius: '50%',
            }}
          />
        </Box>

        {/* Botões */}
        <Box sx={{ mb: 1 }}>
          <PowerButton
            text="Base Power"
            onClick={handleSelectBase}
            variant={selected === 'base' ? 'contained' : 'outlined'}
            selected={selected === 'base'}
          />

        </Box>

        <Box>


          <PowerButton
            text="Redundant Power"
            onClick={handleSelectRedundant}
            variant={selected === 'redundant' ? 'contained' : 'outlined'}
            selected={selected === 'redundant'}
          />
        </Box>

        <p
          style={{
            fontFamily: 'Open Sans',
            fontSize: '12px',
            marginRight: '16%'
          }}
        >
        High-Reliability DC-DC Power Module delivering 
regulated, high-reliability power for satellite avionics, 
based on a compact ADHA-compliant 3U form factor.
        </p>
      </CardContent>
    </Card>
  );
};

export default PowerSupply;
